/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Sort_ActivationInputs */

const en_us2_plan_build_sort_activation = /** @type {(inputs: Plan_Build_Sort_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% activation`)
};

const pt_br2_plan_build_sort_activation = /** @type {(inputs: Plan_Build_Sort_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% ativação`)
};

const es_419_plan_build_sort_activation = /** @type {(inputs: Plan_Build_Sort_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% activación`)
};

const pt_pt2_plan_build_sort_activation = /** @type {(inputs: Plan_Build_Sort_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% ativação`)
};

const fr_fr2_plan_build_sort_activation = /** @type {(inputs: Plan_Build_Sort_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% d'activation`)
};

const de_de2_plan_build_sort_activation = /** @type {(inputs: Plan_Build_Sort_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% Aktivierung`)
};

const it_it2_plan_build_sort_activation = /** @type {(inputs: Plan_Build_Sort_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% attivazione`)
};

/**
* | output |
* | --- |
* | "% activation" |
*
* @param {Plan_Build_Sort_ActivationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_sort_activation = /** @type {((inputs?: Plan_Build_Sort_ActivationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Sort_ActivationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_sort_activation(inputs)
	if (locale === "es-419") return es_419_plan_build_sort_activation(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_sort_activation(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_sort_activation(inputs)
	if (locale === "de-DE") return de_de2_plan_build_sort_activation(inputs)
	if (locale === "it-IT") return it_it2_plan_build_sort_activation(inputs)
	return en_us2_plan_build_sort_activation(inputs)
});
export { plan_build_sort_activation as "plan-build.sort_activation" }